import getStore, { createDefaultSearchStore } from '../store/store';
import { getScenarioIdKey } from 'owa-search-next-common';
import { resetSearchStore } from 'owa-search-next-lazy';
import { mutator } from 'satcheljs';

mutator(resetSearchStore, actionMessage => {
    getStore().scenarioStores.set(
        getScenarioIdKey(actionMessage.scenarioId),
        createDefaultSearchStore()
    );
});
